import { TOKENS, SPENDER_ADDRESS, PROTOCOLS } from './constants'
import { ACTIONS } from '../actions'

const YIELD_BEARING_ASSET = '0x0da67235dd5787d67955420c84ca1cecd4e5bb3b'
const TOKEN_ISSUER = '0x0da67235dd5787d67955420c84ca1cecd4e5bb3b-1645660800'

export default [
  {
    transactions: [
      {
        action: ACTIONS.WRAP,
        paid: [TOKENS.MEMO],
        received: [TOKENS.wMEMO],
        protocol: PROTOCOLS.WONDERLAND,
      },
      {
        action: ACTIONS.MINT,
        paid: [TOKENS.wMEMO],
        received: [TOKENS.OT_wMEMO, TOKENS.YT_wMEMO],
      },
      {
        action: ACTIONS.ADD_LIQUIDITY,
        paid: [TOKENS.OT_wMEMO, TOKENS.MIM],
        received: [TOKENS.OT_wMEMO_MIM],
        protocol: PROTOCOLS.TRADERJOE,
      },
      {
        action: ACTIONS.STAKE,
        paid: [TOKENS.OT_wMEMO_MIM],
        received: [],
      },
      {
        action: ACTIONS.ADD_LIQUIDITY,
        paid: [TOKENS.YT_wMEMO, TOKENS.MIM],
        received: [TOKENS.YT_wMEMO_MIM],
        protocol: PROTOCOLS.PENDLE,
      },
      {
        action: ACTIONS.STAKE,
        paid: [TOKENS.YT_wMEMO_MIM],
        received: [],
      },
    ],
    singleTransactions: [
      {
        action: ACTIONS.WRAP,
        paid: [TOKENS.TIME],
        received: [TOKENS.wMEMO],
        protocol: PROTOCOLS.WONDERLAND,
      },
      {
        action: ACTIONS.MINT,
        paid: [TOKENS.wMEMO],
        received: [TOKENS.OT_wMEMO, TOKENS.YT_wMEMO],
      },
      {
        action: ACTIONS.ADD_LIQUIDITY,
        paid: [TOKENS.OT_wMEMO, TOKENS.MIM],
        received: [TOKENS.OT_wMEMO_MIM],
        protocol: PROTOCOLS.TRADERJOE,
      },
      {
        action: ACTIONS.STAKE,
        paid: [TOKENS.OT_wMEMO_MIM],
        received: [],
      },
      {
        action: ACTIONS.ADD_LIQUIDITY,
        paid: [TOKENS.YT_wMEMO, TOKENS.MIM],
        received: [TOKENS.YT_wMEMO_MIM],
        protocol: PROTOCOLS.PENDLE,
      },
      {
        action: ACTIONS.STAKE,
        paid: [TOKENS.YT_wMEMO_MIM],
        received: [],
      },
    ],
    yieldBearingAsset: YIELD_BEARING_ASSET,
    tokenIssuer: TOKEN_ISSUER,
    inputTokenAddresses: [TOKENS.MEMO, TOKENS.MIM],
    baseTokenAddresses: [TOKENS.TIME, TOKENS.MIM],
    receive: [
      { source: 'staking', tokenAmount: TOKENS.OT_wMEMO_MIM },
      { source: 'staking', tokenAmount: TOKENS.YT_wMEMO_MIM },
    ],
    network: 'avalanche',
    chainId: 43114,
    expiryEpoch: 1645660800,
    spenderAddress: SPENDER_ADDRESS,
    linkToObtain: {
      tokenAddress: TOKENS.MEMO,
    },
    denyInputTypes: ['single'],
  },
  {
    transactions: [
      {
        action: ACTIONS.WRAP,
        paid: [TOKENS.MEMO],
        received: [TOKENS.wMEMO],
        protocol: PROTOCOLS.WONDERLAND,
      },
      {
        action: ACTIONS.MINT,
        paid: [TOKENS.wMEMO],
        received: [TOKENS.OT_wMEMO, TOKENS.YT_wMEMO],
      },
      {
        action: ACTIONS.ADD_LIQUIDITY,
        paid: [TOKENS.OT_wMEMO, TOKENS.MIM],
        received: [TOKENS.OT_wMEMO_MIM],
        protocol: PROTOCOLS.TRADERJOE,
      },
      {
        action: ACTIONS.STAKE,
        paid: [TOKENS.OT_wMEMO_MIM],
        received: [],
      },
    ],
    singleTransactions: [
      {
        action: ACTIONS.WRAP,
        paid: [TOKENS.TIME],
        received: [TOKENS.wMEMO],
        protocol: PROTOCOLS.WONDERLAND,
      },
      {
        action: ACTIONS.MINT,
        paid: [TOKENS.wMEMO],
        received: [TOKENS.OT_wMEMO, TOKENS.YT_wMEMO],
      },
      {
        action: ACTIONS.ADD_LIQUIDITY,
        paid: [TOKENS.OT_wMEMO, TOKENS.MIM],
        received: [TOKENS.OT_wMEMO_MIM],
        protocol: PROTOCOLS.TRADERJOE,
      },
      {
        action: ACTIONS.STAKE,
        paid: [TOKENS.OT_wMEMO_MIM],
        received: [],
      },
    ],
    yieldBearingAsset: YIELD_BEARING_ASSET,
    tokenIssuer: TOKEN_ISSUER,
    inputTokenAddresses: [TOKENS.MEMO, TOKENS.MIM],
    baseTokenAddresses: [TOKENS.TIME, TOKENS.MIM],
    receive: [
      { source: 'staking', tokenAmount: TOKENS.OT_wMEMO_MIM },
      { source: 'wallet', tokenAmount: TOKENS.YT_wMEMO },
    ],
    network: 'avalanche',
    chainId: 43114,
    expiryEpoch: 1645660800,
    spenderAddress: SPENDER_ADDRESS,
    linkToObtain: {
      tokenAddress: TOKENS.MEMO,
    },
    denyInputTypes: ['single'],
  },
  {
    transactions: [
      {
        action: ACTIONS.WRAP,
        paid: [TOKENS.MEMO],
        received: [TOKENS.wMEMO],
        protocol: PROTOCOLS.WONDERLAND,
      },
      {
        action: ACTIONS.MINT,
        paid: [TOKENS.wMEMO],
        received: [TOKENS.OT_wMEMO, TOKENS.YT_wMEMO],
      },
      {
        action: ACTIONS.ADD_LIQUIDITY,
        paid: [TOKENS.YT_wMEMO, TOKENS.MIM],
        received: [TOKENS.YT_wMEMO_MIM],
        protocol: PROTOCOLS.PENDLE,
      },
      {
        action: ACTIONS.STAKE,
        paid: [TOKENS.YT_wMEMO_MIM],
        received: [],
      },
    ],
    singleTransactions: [
      {
        action: ACTIONS.WRAP,
        paid: [TOKENS.TIME],
        received: [TOKENS.wMEMO],
        protocol: PROTOCOLS.WONDERLAND,
      },
      {
        action: ACTIONS.MINT,
        paid: [TOKENS.wMEMO],
        received: [TOKENS.OT_wMEMO, TOKENS.YT_wMEMO],
      },
      {
        action: ACTIONS.ADD_LIQUIDITY,
        paid: [TOKENS.YT_wMEMO, TOKENS.MIM],
        received: [TOKENS.YT_wMEMO_MIM],
        protocol: PROTOCOLS.PENDLE,
      },
      {
        action: ACTIONS.STAKE,
        paid: [TOKENS.YT_wMEMO_MIM],
        received: [],
      },
    ],
    yieldBearingAsset: YIELD_BEARING_ASSET,
    tokenIssuer: TOKEN_ISSUER,
    inputTokenAddresses: [TOKENS.MEMO, TOKENS.MIM],
    baseTokenAddresses: [TOKENS.TIME, TOKENS.MIM],
    receive: [
      { source: 'staking', tokenAmount: TOKENS.YT_wMEMO_MIM },
      { source: 'wallet', tokenAmount: TOKENS.OT_wMEMO },
    ],
    network: 'avalanche',
    chainId: 43114,
    expiryEpoch: 1645660800,
    spenderAddress: SPENDER_ADDRESS,
    linkToObtain: {
      tokenAddress: TOKENS.MEMO,
    },
    denyInputTypes: ['single'],
  },
]
